/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class Feeding {
    'id': number;
    'supplaments'?: Array<string>;
    'dtCreated': Date;
    'dtStart'?: Date;
    'dtEnd'?: Date;
    'hayMorning'?: number;
    'hayAfternoon'?: number;
    'hayEvening'?: number;
    'note'?: string;
    'currentPlan'?: boolean;
    'horse': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "supplaments",
            "baseName": "supplaments",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dtStart",
            "baseName": "dtStart",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dtEnd",
            "baseName": "dtEnd",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "hayMorning",
            "baseName": "hayMorning",
            "type": "number",
            "format": "double"
        },
        {
            "name": "hayAfternoon",
            "baseName": "hayAfternoon",
            "type": "number",
            "format": "double"
        },
        {
            "name": "hayEvening",
            "baseName": "hayEvening",
            "type": "number",
            "format": "double"
        },
        {
            "name": "note",
            "baseName": "note",
            "type": "string",
            "format": ""
        },
        {
            "name": "currentPlan",
            "baseName": "currentPlan",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "horse",
            "baseName": "horse",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Feeding.attributeTypeMap;
    }

    public constructor() {
    }
}

